import { render, staticRenderFns } from "./CategoryServicesView.vue?vue&type=template&id=9db60602&scoped=true"
import script from "./CategoryServicesView.vue?vue&type=script&lang=js"
export * from "./CategoryServicesView.vue?vue&type=script&lang=js"
import style0 from "./CategoryServicesView.vue?vue&type=style&index=0&id=9db60602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db60602",
  null
  
)

export default component.exports